import React from 'react';
import { connect } from 'react-redux';
import { Label, Table } from 'semantic-ui-react';
import HoverActionButtons from '@/components/buttons/HoverActionButtons';
import { showDictionaryLookups } from '../../dictionaries/actions';
import { editDataset } from '../../actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldTypeLookup = ({
  code,
  category,
  constraint,
  showEdit,
  canEdit,
  showLookupDialog,
  disabled,
  template,
}) => (
  <Table.Cell>
    <HoverActionButtons
      canEdit={canEdit}
      showEdit={() => showEdit(category, code, template)}
      value={constraint}
      editCopyMods="table-cell table-cell--fieldname"
      disabled={disabled}
    >
      <Label
        basic
        as="a"
        size="large"
        className="button-link-block"
        onClick={() => showLookupDialog(category, code, constraint, canEdit)}
        content={constraint}
      />
    </HoverActionButtons>
  </Table.Cell>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps);
  return ({ disabled: !editable, template });
};

const mapDispatchToProps = {
  showEdit: editDataset,
  showLookupDialog: showDictionaryLookups,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldTypeLookup);
